import { render, staticRenderFns } from "./VideoLateral.vue?vue&type=template&id=05bedff7&scoped=true&"
import script from "./VideoLateral.vue?vue&type=script&lang=js&"
export * from "./VideoLateral.vue?vue&type=script&lang=js&"
import style0 from "./VideoLateral.vue?vue&type=style&index=0&id=05bedff7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bedff7",
  null
  
)

export default component.exports